import {FirebaseFunctionsError} from '../../shared/customerrors.js';
var QRCode = require('qrcode');
var DOMPurify = require('dompurify');

class TemplateBuilderCtrl {
  constructor(
    $uibModal,
    $scope,
    $window,
    $state,
    $timeout,
    FEService,
    TBService,
    EventService,
    TemplateService,
    TemplateValidationService,
    TokenRefreshService,
    ScriptLoaderService,
    FlashService,
    UrlClipCopy,
    SchemaService,
    DomService,
    AuthService,
    FormBuilderService) {

    'ngInject';

    Object.assign(this, { $state, $window, $timeout, $uibModal, $scope });
    this.fe = FEService;
    this.fs = FlashService;
    this.tb = TBService;
    this.ss = SchemaService;
    this.as = AuthService;
    this.fbs = FormBuilderService;
    this.trs = TokenRefreshService; // Do not remove
    this.dom = DomService;
    this.ts = TemplateService;
    this.tv = TemplateValidationService;
    this.es = EventService;
    this.uc = UrlClipCopy;

    this.loading = 'Loading Template...';
    this.tokenLoadCount = 0;

    ScriptLoaderService.importExternalPageScripts('builder');

    this.td = {};
    this.pageNumber = 1; // Start with page number using base 1
    this.duplicatingTemplate = false;
    this.discardOption = false;
    this.showTokensContextMenu = false;
    this.showPageContextMenu = false;
    this.selectedTokens = [];
    this.validationState = { };
    this.errorLevel = 0;
    this.pageZoom = "100";
    this.activePage = null;
  }

  async $onInit() {

    $('body').css('overflow-y', 'hidden');

    try {
      this.subscribePreEvents();

      [this.PROVIDER, this.td, this.realm] = await Promise.all([
        this.as.getProviderSettings(),
        this.ts.getTemplateData(),
        this.as.realm()
      ]);
      

      if (!this.td) {
        this.fs.error("Cannot load template data! You may need to update your connection!");
        return;
      }
      if (this.td.template.realm !== this.realm) {
        this.fs.error(`You are logged in to ${this.realm}! Please login again to ${this.td.template.realm}.`);
        this.as.logout();
        return;
      }

      this.setConfirmLeave();

      this.loading = '';

      this.$timeout(() => {
        this.$tokensContextMenu = $('#tokens-context-menu');
        this.$pageContextMenu = $('#page-context-menu');
        this.$tokenSelector = $("#token-selector");
        this.$builderContainerScroll = $('#builder-container-scroll');
        this.$builderContainer = $('#builder-container');

        this.resizeWindow();
        this.bindComponentEvents();
        this.validateMissingRequired();
        this.validateEmptyReferences();
        this.validateTableFields();
        this.validateChoiceFields(); 
        this.validateSelectOptions();
        this.validateTemplateSettings(true);
      });
      
      // TODO: Don't trust the DOM (.click)
      if (this.$state.params.links === "true") angular.element('#links-btn').click();
      this.$scope.$apply(); //prevents occasional hanging on <loader>
      this.tabNumbers = null;
      this.dragImage = document.createElement('img');
      this.dragImage.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
      this.loadFonts();
      this.setActivePage(1);
    } 
    catch (error) {
      const backendError = error instanceof FirebaseFunctionsError;
      !backendError && console.error(error);
      this.handleError(error, backendError);
    }
  }

  $onDestroy() {
    this.ts.dispose();
    this.tv.dispose();
    this.es.disposeSubscribers("template");
    this.$window.onbeforeunload = undefined;
    this.$state.$current.onExit = undefined;
  }
  
  handleError(error, fatal) {
    this.fs.error(`${error.message || error.toString()}`);
    fatal && this.$state.go('app.form-builder');
  }

  loadFonts() {
    this.fe.loadMissingFonts(false, false)
      .then((error) => { 
        if (error === true) 
          this.fs.error("Error loading fonts, please verify you're using valid Google fonts: https://fonts.google.com");
      });
  }

  //#region Save
  async saveChanges() {

    this.loading = 'Saving...';

    this.deselectAllTokens();
    this.setTokenGroupStyle();

    // Sanitize content
    const {successMessage, passkeyMessage, customCss} = this.td.template;
    this.td.template.successMessage = successMessage ? DOMPurify.sanitize(successMessage, { USE_PROFILES: {html: true} } ) : null;
    this.td.template.passkeyMessage = passkeyMessage ? DOMPurify.sanitize(passkeyMessage, { USE_PROFILES: {html: true} } ) : null;
    this.td.template.customCss = customCss ? 
      DOMPurify.sanitize(`<style>${customCss}</style>`, { FORCE_BODY: true } )
        .replace('<style>', '').replace('</style>', '') : null;

    this.td = await this.ts.saveTemplateData(this.td);
    this.PROVIDER.migrateTemplateToProvider && this.migrateProviderTemplate();
    
    //this.dom.clearCache();
    this.loading = '';
    this.tabNumbers = null;
    this.errorLevel = 0;

    this.ts.notifyUpdate(null, this.td, true);

    this.$timeout(() => {
      this.$scope.$apply();
      this.validateMissingRequired();
      this.validateTableFields();
      this.validateChoiceFields();
      this.validateSelectOptions();
      this.validateEmptyReferences();
      this.validateTemplateSettings(false);
    });

    this.fs.success("Template Saved");
  }

  migrateProviderTemplate() {
    if (!this.fe.isLocal()) {
      this.fbs.exportTemplate(this.td.template, true)
        .then(response => {
          if (response.data.success == true) {
            this.fs.success('The template was updated on the provider successfully!');
          } else if (response.data.success == false) {
            this.fs.warning('The template can be updated automatically on the provider once you export it for the first time!');
          }
        }, response => {
          this.fs.error('The provider returned an error while exporting the template!');
        });
    }
    else {
      this.fs.warning('Templates are not migrated automatically to the provider when running locally!');
    }
  }

  async saveChangesAs(versionToRestore=null) {
    this.loading = "Copying Template...";
    this.duplicatingTemplate = true; //prevents onExit Dialogue box
    let title = `${this.td.template.title} - Copy`;
    const origTemplate = this.ts.originalTemplateData.template;
    if (origTemplate.title !== this.td.template.title) {
      title = this.td.template.title;
    }
    this.td.template.title = title;

    this.ignoreLeaveConfirm = true;

    const partialTemplate = angular.copy(this.td.template);
    try {
      const { "data": { "template": { id } } } = await this.tb.copyTemplate({ partialTemplate, versionToRestore });
      this.$state.go(
        'app.template-builder',
        { 'templateId': id },
        { reload: true } //refreshes page
      );
    } catch (error) {
      this.duplicatingTemplate = false; //prevents onExit Dialogue box
      this.fs.error(error);
    } 
  }

  async copyQrImage() {
    const filename = `Submit ${this.ts.template.title} qr.png`;
    const url = await QRCode.toDataURL(this.submitUrl);
    this.uc.copyImg(url, filename);
  }

  discardChanges() {
    this.discardOption = true;

    this.$state.go(
      'app.template-builder',
      { 'templateId': this.td.template.id },
      { reload: true } //refreshes page
    );
  }

  hasUnsavedChanges() {
    return this.ts.templateHasChanges(this.td?.template);
  }

  deleteSelectedTokens() {
    if (confirm(`Remove ${this.selectedTokens.length} selected fields?`)) {
      this.deleteTokens(this.selectedTokens);
    }
    this.deselectAllTokens();
    this.deactivateContextMenus();
  }

  deleteTokens(tokens, closeModal) {
    closeModal && this.closeModal();
    
    this.$timeout(_ => {
      tokens.forEach(t => this.ts.removeToken(t.id));
      this.deselectAllTokens();
      this.validateMissingRequired();
      this.validateTableFields();
      this.validateChoiceFields();
      this.validateSelectOptions();
      this.validateEmptyReferences();
      this.tabNumbers = null;
      this.ts.notifyUpdate(["tokens", "behaviors", "conditions"], this.td);
    }, 100);
  }

  isSaveDisabled() {
    return this.loading || !this.hasUnsavedChanges() || this.tokenLoadCount;
  }
  //#endregion Save

  //#region Window events
  bindComponentEvents() {
    $(window).unbind('keydown keyup');
    $(window).bind('keydown', event => { this.keyDown(event) });
    // the following keyup event does not fire...
    $(window).bind('keyup', event => { this.keyUp(event) });
    $(window).unbind('resize');
    $(window).bind('resize', () => { this.resizeWindow() });
    this.$builderContainer.unbind('dragover dragstart dragend');
    this.$builderContainer.bind('dragover', event => { this.backgroundDragOver(event) });
    this.$builderContainer.bind('dragstart', event => { this.backgroundDragStart(event) });
    this.$builderContainer.bind('dragend', event => { this.backgroundDragEnd(event) });
    this.$builderContainerScroll.unbind('scroll');
    this.$builderContainerScroll.bind('scroll', _ => { this.builderScroll() });

    this.subscribeEvents();
    
  }

  subscribePreEvents() {
    this.es.subscribeEvent(
      this.es.actions.AUTHENTICATE, 
      async data => {
        if (data.updateConnection) {
          await this.updateConnection();
          return;
        }
        this.ignoreLeaveConfirm = true;
        this.as.logout(null, data.error);
      },
      'AUTHENTICATE_STATIC');

    this.es.subscribeEvent(
      this.es.actions.INTERNAL_ERROR, 
      data => {
        this.loading = '';
        this.fs.error(data.error.message);
      },
      'INTERNAL_ERROR_STATIC');
  }

  subscribeEvents() {

    this.ts.subscribeUpdate(
      (options) => { 
        this.ts.updateTemplateData(this.td, options);
        if (!options.keys?.length || options.keys.includes('appId')) {
          this.$timeout(_ => { 
            this.selectedReferenceId = null;
            this.deselectAllTokens(); 
          });
        }
        if (!options.keys?.length || options.keys.includes('references')) {
          this.$timeout(_ => { 
            this.validateMissingRequired();
            this.validateEmptyReferences();
            this.validateTemplateSettings(false);
          });
        }
      },
      'TEMPLATE_DATA_UPDATED_STATIC');

    this.es.subscribeEvent(
      this.es.actions.SAVE_TEMPLATE, 
      (data) => { this.saveChanges(data); this.modal?.close() },
      'SAVE_TEMPLATE_STATIC');

    this.es.subscribeEvent(
      this.es.actions.TOKEN_SELECTED, 
      (data) => { this.selectTokenCallback(data) },
      'TOKEN_SELECTED_STATIC');

    this.es.subscribeEvent(
      this.es.actions.TOKENS_DESELECTED, 
      () => { this.deselectAllTokens() },
      'TOKENS_DESELECTED_STATIC');

    this.es.subscribeEvent(
      this.es.actions.TEMPLATE_VALIDATED, 
      (results) => { 
        this.$timeout(() => { 
          this.validationState = results.SUMMARY;
          if (!this.validationState.valid && (this.errorLevel != this.validationState.level.value)) {
            this.validationState.level.key && this.fs[this.validationState.level.key](this.validationState.level.warning);
          }
          this.errorLevel = this.validationState.level.value;
        });
      },
      'TEMPLATE_VALIDATED_STATIC');

    this.es.subscribeEvent(
      this.es.actions.TOKEN_REMOVE, 
      (data) => { 
        this.$timeout(_ => this.deleteTokens([data.token], true));
      },
      'TOKEN_REMOVE_STATIC');

    this.es.subscribeEvent(
      this.es.actions.TEMPLATE_ZOOM, 
      (data) => { 
        this.dom.clearCache();
        this.deselectAllTokens();
        this.setPageZoom(data.zoom);
      },
      'TEMPLATE_ZOOM_STATIC');

    this.es.subscribeEvent(
      this.es.actions.MOUSE_ENTERED_BUILD_HEADER, 
      _ => this.mouseEnteredBuildHeader(),
      'MOUSE_ENTERED_BUILD_HEADER_STATIC');

    this.es.subscribeEvent(
      this.es.actions.CONFIG_TARGET_TABLE, 
      refId => {
        this.openTemplateOptions(refId, '#panelUploadField');
      },
      'CONFIG_TARGET_TABLE_STATIC');

    this.es.subscribeEvent(
      this.es.actions.CONFIG_TOKEN, 
      data => this.openTokenModal(this.getTokenById(data.tokenId), "OPTIONS"),
      'CONFIG_TOKEN_STATIC');

    this.es.subscribeEvent(
      this.es.actions.GOTO_PAGE, 
      data => this.scrollToPage(data.pageNumber),
      'GOTO_PAGE_STATIC');

    this.es.subscribeEvent(
      this.es.actions.RESTORE_TEMPLATE,
      (data) => this.$timeout(() => this.restoreTemplateVersion(data)));
  }

  resizeWindow() {
    if (!this.$builderContainerScroll || !this.$builderContainerScroll[0]) return;
    // This check is required when rezising tokens:
    if (this.windowSize?.innerWidth == this.$window.innerWidth && this.windowSize?.innerHeight == this.$window.innerHeight) return;
    this.$builderContainer.css('width', `${this.$builderContainerScroll[0].clientWidth}px`);
    this.windowSize = { innerWidth: this.$window.innerWidth, innerHeight: this.$window.innerHeight };
    this.deselectAllTokens();
  }

  setPageZoom(zoom) {
    this.pageZoom = zoom;
    this.$builderContainer.css('width', this.pageZoom + '%');
  }

  builderScroll() {
    this.deactivateContextMenus();
    this.setTokenGroupStyle();
    this.setActivePage();
  }
  //#endregion Window events

  //#region Token manipulation
  tokensDragEnd(event, ui, adjustPage) { 
    if (this.activePageId == null) return;
    const adjustment = adjustPage ? this.adjustSelectedTokenPage(ui): null;
    let resize = false;
    const $page = $(`#page-preview-window-${this.selectedTokens[0].pageId}`);
    this.selectedTokens.forEach(t => delete t.options?.snappedToField);
    if (adjustPage && adjustment.adjust) {
      const $helper = $($page.find('.token-group-selected')[0]);
      $helper.css('top', adjustment.newTop);
      if (adjustment.proportion != 1) {
        resize = true;
        $helper.find("*").each((i, elm) => {
          const $elm = $(elm);
          $elm.css('height', $elm.height() * adjustment.proportion);
        });
      }
    }
    const $newPage = adjustPage ? $(`#page-preview-window-${adjustment.pageId}`): $page;
    this.applySelectedTokenTransform($page, $newPage, resize, adjustPage ? adjustment.proportion : 1);
    if (adjustPage && adjustment.adjust) {
      this.selectedTokens.forEach( t => {
        t.pageId = adjustment.pageId;
      });
      this.activePageId = adjustment.pageId;
      this.$scope.$apply();
    }
    this.$timeout(() => { 
      this.updateTokenData();
      if (event?.originalEvent?._tokenDragCallback) {
        if (this.selectedTokens.length === 1) event.originalEvent._tokenDragCallback(this.selectedTokens[0]);
        else this.fs.error("Multiple fields selected, cannot snap to field position!");
      }
      this.setTokenGroupStyle();
      this.tabNumbers = null;
    });
  }

  tokensResizeEnd($evt, $ui) {
    const $page = $($($ui.helper[0]).parents('.page-preview-window')[0]);
    this.applySelectedTokenTransform($page, $page, true, 1);
    this.updateTokenData();
    this.setTokenGroupStyle();
    this.tabNumbers = null;
  }

  adjustSelectedTokenPage($ui) {
    const $page = $($($ui.helper[0]).parents('.page-preview-window')[0]);
    const $helper = $($page.find('.token-group-selected')[0]);
    let pageId = $page.attr('id').replace('page-preview-window-', '');
    let boundingBox = this.dom.getJqCssVals($helper, ['height', 'top']);
    let initialPageHeight = $page.height();
    let currentPageHeight = initialPageHeight;
    let pageNum = this.td.template.partialPages.find(p => p.id === pageId).pageNumber;
    let proportion = 1;
    let adjustTokens = false;
    let pageFound = false;
    let topLimit = false;
    
    // Move to next page
    if (boundingBox.top  > currentPageHeight) {
      while (!pageFound) {
        pageNum++;
        boundingBox.top -= currentPageHeight;
        const nextPageId = this.td.template.partialPages.find(p => p.pageNumber == pageNum).id;
        const nextPageHeight = $(`#page-preview-window-${nextPageId}`).height();
        pageFound = (boundingBox.top <= nextPageHeight);
        currentPageHeight = nextPageHeight;
      }
      adjustTokens = true;
    }
    // Move to prev page
    else if (boundingBox.top < 0) {
      boundingBox.top *= -1;
      while (!pageFound) {
        pageNum--;
        topLimit = (pageNum == 0);
        pageNum = Math.max(pageNum, 1);
        const prevPageId = this.td.template.partialPages.find(p => p.pageNumber == pageNum).id;
        const prevPageHeight = $(`#page-preview-window-${prevPageId}`).height();
        if (boundingBox.top <= prevPageHeight || pageNum == 1) {
          pageFound = true;
          boundingBox.top = prevPageHeight - boundingBox.top;
        }
        else {
          boundingBox.top -= prevPageHeight;
        }
        currentPageHeight = prevPageHeight;
      }
      adjustTokens = !topLimit;
    }
    // Adjust to page limits
    if (!topLimit && (boundingBox.top + boundingBox.height) > currentPageHeight) {
      boundingBox.top = currentPageHeight - boundingBox.height;
      adjustTokens = true;
    }
    
    if (adjustTokens) {
      const newPage = this.td.template.partialPages.find(p => p.pageNumber == pageNum);
      proportion = currentPageHeight / initialPageHeight;
      pageId = newPage.id;
    }

    return { pageId, newTop: boundingBox.top, proportion, adjust: adjustTokens };
  }

  applySelectedTokenTransform($page, $newPage, resize, proportion) {
    const $helper = $($page.find('.token-group-selected')[0]);
    const page = { height: $newPage.height(), width: $newPage.width() };
    const offset = $helper.position();
    $helper.find("*").each((i, elm) => {
      const $elm = $(elm);
      const id = $elm.attr('id').replace('token-', '');
      const token = this.getTokenById(id);
      const dims = this.dom.getJqCssVals($elm, ['height', 'width', 'top', 'left']);
      const top = ((offset.top + (dims.top * proportion)) * 100) / page.height;
      const left = ((dims.left + offset.left) * 100) / page.width;
      
      const newCss = {
        top: top + '%',
        left: left + '%',
        ...resize && this.tb.getResizeCss(token, dims, token.fieldSchema)
      };
      this.tb.safeApplyTokenCss(token, newCss);
    });
    $helper.empty();
  }
  //#endregion Token manipulation

  //#region Page events
  pageRightClick(page, event) {
    this.contextMenuPage = page;
    this.$timeout(() => { this.activatePageContextMenu(event) });
  }

  removeActivePage(page) {
    if (this.td.template.partialPages.length < 2)
      return this.fs.error(`Error: Cannot remove single page!`);
    if (!confirm(`Are you sure you want to remove page  ${page.pageNumber}?`)) return;

    const curPageNum = page.pageNumber;
    const countFields = this.removePageTokens(page);
    this.ts.removePage(page.id);
    
    this.arrangePageNumbers();
    this.ts.notifyUpdate(["partialPages"], this.td);

    this.$timeout(() => { this.deactivateContextMenus() });
    this.fs.success(`Page ${ curPageNum } ${ (countFields > 0) ? `and its ${countFields} fields were`: 'was'} removed!`);
  }

  clearActivePage(page) {
    if (!confirm(`Are you sure you want to remove the fields in page ${page.pageNumber}?`)) return;
    const countFields = this.removePageTokens(page);
    this.$timeout(() => { this.deactivateContextMenus() });
    if (countFields) this.fs.success(`${countFields} fields were removed from the page!`);
    else this.fs.error(`Page contains no fields!`);
  }

  removePageTokens(page) {
    const fields = this.td.template.tokens.filter(t => t.pageId == page.id);
    const count = fields.length;
    this.deleteTokens(fields);
    return count;
  }

  arrangePageNumbers() {
    let pageNum = 1;
    this.td.template.partialPages
      .sort((a, b) => a.pageNumber - b.pageNumber)
      .forEach(p => {
        p.pageNumber = pageNum++;
      });
  }

  moveActivePage(page, direction) {
    const directionStr = direction == 1 ? 'up' : 'down';
    const positionStr = direction == 1 ? 'before' : 'after';
    const origPage = page.pageNumber;
    const destPage = origPage - direction;
    this.swapPages(page, destPage);

    this.ts.notifyUpdate(["partialPages"], this.td);
    this.$timeout(_ => this.deactivateContextMenus());
    this.fs.success(`Page ${origPage} was moved ${directionStr}, ${positionStr} page ${destPage}!`);
  }

  swapPages(page, destPageNumber) {
    const targetPage = this.td.template.partialPages.find(p => p.pageNumber == destPageNumber);
    const prevPageNum = page.pageNumber;
    page.pageNumber = targetPage.pageNumber;
    targetPage.pageNumber = prevPageNum;
  }

  setActivePageBg() {
    if (this.hasUnsavedChanges()) return this.fs.error('Please save your changes first!');
    this.openTemplateOptions(null, ".template-background");
    this.$timeout(_ => this.deactivateContextMenus());
  }

  setActivePageNumber(page, pageNumber, swap) {
    const origPageNumber = page.pageNumber;
    if (pageNumber == origPageNumber)
      return this.fs.error("No changes detected!");
    
    swap ||= (Math.abs(pageNumber - origPageNumber) == 1);

    if (swap) this.swapPages(page, pageNumber);
    else {
      const movDirection = (page.pageNumber > pageNumber) ? 1 : -1;
      this.td.template.partialPages
        .filter(p => 
          (movDirection == 1 && p.pageNumber >= pageNumber) 
          || 
          (movDirection == -1 && p.pageNumber <= pageNumber))
        .forEach(p => p.pageNumber += movDirection);
      page.pageNumber = pageNumber;
      this.arrangePageNumbers();
    }

    this.ts.notifyUpdate(["partialPages"], this.td);
    this.$timeout(_ => this.deactivateContextMenus());
    this.fs.success(swap ? `Page ${origPageNumber} was swaped with page ${pageNumber}!` : `Page moved from ${origPageNumber} to ${pageNumber}!`);
  }
  //#endregion Page events

  //#region Token events
  tokenRightClick(id, event) {
    event.stopPropagation();

    // Consider right click on unselected token, different combinations...
    const token = this.getTokenById(id);
    if (!this.dom.isCtrlPressed(event)) {
      if (token && !this.selectedTokens.some(t => t.id == token.id)) {
        this.deselectAllTokens();
      }
    }
    this.activeToken = token;
    this.selectToken(this.activeToken);
    
    this.$timeout(() => {this.activateTokenContextMenu(event)});
  }

  tokenDoubleClick(id, event) {
    event.stopPropagation();
    if (this.selectedTokens.length > 1) this.setCommonTokenStyles();
    else this.openTokenModal(this.ts.tokens.find(t => t.id == id));
  }

  keyUp(event) {
    if (!this.designerIsFocused() || !this.keyDownHandled) return;
   
    let preventDefault = false;

    switch (event.code) {
      case 'Tab':
        var currentToken = this.selectedTokens.length ? this.selectedTokens[0] : null;
        preventDefault = true;
        if (this.tabNumbers == null) this.updateTokensTabIndexes();
        this.selectNextToken(event, currentToken);
        break;
      case 'Enter':
        if (this.selectedTokens.length == 1) {
          preventDefault = true;
          this.openTokenModal(this.selectedTokens[0]);
        }
        break;
      case 'Escape':
        if (this.selectedTokens.length > 0) {
          preventDefault = true;
          this.deselectAllTokens();
        }
        break;
      case 'KeyS':
        this.saveChanges();
        break;
    }
    preventDefault && event.preventDefault();
    this.keyDownHandled = false;
  }

  keyDown(event) {
    if (!this.designerIsFocused()) return;

    let left = 0, top = 0;
    let preventDefault = false;
    const selectedCount = this.selectedTokens.length;
    const ctrlPressed = this.dom.isCtrlPressed(event);
    this.modalClosing = ($('.modal').length > 0);

    switch(event.code) {
      case 'Tab':
      case 'Escape':
      case 'Enter':
        preventDefault = true;
        this.keyDownHandled = true;
        break;
      case 'KeyS':
        if (ctrlPressed){
          preventDefault = true;
          this.keyDownHandled = true;
        }
        break;
      case 'ArrowDown':
        top = 1;
        break;
      case 'ArrowUp':
        top = -1;
        break;
      case 'ArrowLeft':
        left = -1;
        break;
      case 'ArrowRight':
        left = +1;
        break;
      case 'Backspace':
      case 'Delete':
        if(selectedCount > 0) {
          preventDefault = true;
          this.deleteSelectedTokens();
        }
        break;
    }

    if (selectedCount && (left || top)) {
      const pageDims = this.dom.getPageSize(this.activePageId);
      const $tokenGroup = $(`#token-group-selected-${this.selectedTokens[0].pageId}`);
      const selDimensions = this.getTokenGroupStyle();
      if (left && 
        ((selDimensions.right + left) < pageDims.width) && 
        ((selDimensions.left + left) > 0)) {
        $tokenGroup.css('left', selDimensions.left + left);
      }
      if (top &&
        ((selDimensions.bottom + top) < pageDims.height) &&
        ((selDimensions.top + top) > 0)) {
        $tokenGroup.css('top', selDimensions.top + top);
      }
      preventDefault = true;
      this.tokensDragEnd(null, null, false);
      this.setTokenGroupStyle();
    }
    preventDefault && event.preventDefault();
  }
  //#endregion Token events

  //#region Token organization tools
  fitTokens(cssAttr, limit) {
    const target = this.selectedTokens.reduce( (acc, t) => {
      const val = this.dom.tokenDim(t, cssAttr);
      return limit ? Math.max(val, acc) : Math.min(val, acc);
    }, limit ? 0 : this.dom.getPageSize(this.activePageId)[cssAttr]);

    this.selectedTokens.forEach(t => {
      const dims = {[cssAttr]: target};
      const sizeCss = this.tb.getResizeCss(t, dims, t.fieldSchema);
      this.tb.safeApplyTokenCss(t, sizeCss);
    });

    this.setTokenGroupStyle();
    this.deactivateContextMenus();
  }

  stackTokens(direction) {
    const sizeAttr = (direction === 'horizontal') ? 'width' : 'height';
    const offsetAttr = (direction === 'horizontal') ? 'left' : 'top';
    const ordered = this.dom.sortByAttr(this.selectedTokens, offsetAttr);
    const sum = ordered.reduce((acc, t) => acc + this.dom.tokenDim(t, sizeAttr), 0);
    const pageSize = this.dom.getPageSize(this.activePageId)[sizeAttr];
    
    if(sum > pageSize) {
      return this.fs.error('Error: Stacking tokens would exceed page boundary');
    }
    const offset = this.dom.tokenDim(ordered[0], offsetAttr);
    const offsetNew = (offset + sum > pageSize) ? pageSize - sum : offset;
    ordered.reduce( (acc, token, i) => {
      const newCss = {[offsetAttr]: this.tb.pxValToPct(acc, pageSize)};
      this.tb.safeApplyTokenCss(token, newCss);
      return acc + this.dom.tokenDim(token, sizeAttr);
    }, offsetNew);
    
    this.setTokenGroupStyle();
    this.deactivateContextMenus();
  }

  alignTokens(position) {
    const limit = (position == 'right' || position == 'bottom');
    const offsetAttr = (position == 'left' || position == 'right') ? 'left' : 'top';
    const sizeAttr = (offsetAttr == 'left') ? 'width' : 'height';
    const pageSize = this.dom.getPageSize(this.activePageId)[sizeAttr];
    
    const newPosition = this.selectedTokens.reduce( (acc, t) => {
      return limit 
        ?  Math.max(acc, this.dom.tokenDim(t, offsetAttr) + this.dom.tokenDim(t, sizeAttr))
        :  Math.min(acc, this.dom.tokenDim(t, offsetAttr));
    }, limit ? 0 : pageSize);
    
    this.selectedTokens.forEach(t => {
      let elemPosition = newPosition;
      if (limit) {
        elemPosition -= this.dom.tokenDim(t, sizeAttr);
      }
      const newCss = {[offsetAttr]: this.tb.pxValToPct(elemPosition, pageSize)};
      this.tb.safeApplyTokenCss(t, newCss);
    });
    
    this.setTokenGroupStyle();
    this.deactivateContextMenus();
  }

  setCommonTokenStyles() {

    const cssObjs = this.selectedTokens.map(t => this.tb.getCssObj(t.layout));
    if (!cssObjs.length) return;

    this.commonTokenCss = this.tb.getCssObjSharedStyles(cssObjs);
    this.removedProps = [];
    this.invalidCss = false;
    
    this.modal = this.$uibModal.open({
      backdrop: 'static',
      template: `
      <div class="modal-header">
        <h3 class="modal-title">Set common field styles</h3>
      </div>
      <div class="modal-body">
        <css-builder css="$ctrl.commonTokenCss" title="'Styles'" invalid-css="$ctrl.invalidCss"
          removed-props="$ctrl.removedProps" validate ="true"></css-builder>
      </div>
      <div class="modal-footer">
        <div class="btn-group btn-group-justified" role="group" aria-label="...">
          <div class="btn-group" role="group">
            <button type="submit" class="btn btn-primary" ng-disabled="$ctrl.invalidCss"
              ng-click="$ctrl.applyCommonTokenStyles()">Apply</button>
          </div>
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-warning" 
              ng-click="$ctrl.closeModal()">Cancel</button>
          </div>
        </div>
      </div>`,
      scope: this.$scope,
      size: 'lg'
    });

    this.deactivateContextMenus();
  }

  applyCommonTokenStyles() {
    this.closeModal();

    const newLayout = this.tb.getCssObj(this.commonTokenCss);
    this.selectedTokens.forEach(t => {
      let origObj = (this.tb.getCssObj(t.layout) || {});
      this.removedProps.forEach(key => delete origObj[key]);
      t.layout = this.tb.getLayoutFromCssObj({ ...origObj, ...newLayout });
    });
    
    this.updateTokenData();
    this.$timeout(() => {
      this.setTokenGroupStyle();
      this.loadFonts();
    });
  }
  //#endregion Token organization tools

  //#region Token selection
  
  deselectedTokenClick(event, token) {
    event.stopPropagation();

    this.deactivateContextMenus();
    if (!this.dom.isCtrlPressed(event)) {
      this.deselectAllTokens();
    }
    this.activeToken = token;
    this.selectToken(token);
  }

  selectedTokenClick(index, event) {
    this.deactivateContextMenus();
    event.stopPropagation();
    if (this.dom.isCtrlPressed(event)) 
      this.deselectToken(this.selectedTokens[index]);
  }

  deselectToken(token) {
    token._selected = false;
    this.selectedTokens = this.selectedTokens.filter(t => t.id !== token.id);
    this.setTokenGroupStyle();
  }

  updateTokensTabIndexes() {
    this.tabNumbers = this.dom.getTabNumbers(this.td.template.partialPages, this.td.template.tokens);
  }

  selectNextToken(event, token = null) {
    const tabEntries = Object.entries(this.tabNumbers);
    const length = tabEntries.length;
    const getTk = i => tabEntries.find(o => o[1] == i)[0];
    let tokenIndex = 1;

    if (!token) {
      token = this.td.template.tokens.find(t => t.id == getTk(tokenIndex));
    }
    else {
      tokenIndex = this.tabNumbers[token.id];
      this.dom.isShiftPressed(event) ? tokenIndex-- : tokenIndex++;
    }

    if (tokenIndex > length) tokenIndex = 1;
    else if (tokenIndex < 1) tokenIndex = length;

    const selToken = this.td.template.tokens.find(t => t.id == getTk(tokenIndex));

    this.scrollToToken(selToken, true);
    this.$timeout(() => { this.deselectAllTokens(); this.selectToken(selToken) }, 400); // wait for token to be visible after scroll
  }

  selectTokenCallback(token) {
    this.deselectAllTokens(false);
    this.selectTokenReference(token);
    this.scrollToToken(token, true);
    this.activePageId = token.pageId;
    this.$timeout(() => { this.selectToken(token) }, 400);
  }

  scrollToToken(token, center = false) {
    const $token = this.dom.getJqToken(token);
    const tokenTop = $token.position().top;
    const tokenHeight = $token.height();
    const scrollHeight = this.$builderContainerScroll.height();
    const scrollTop = this.$builderContainerScroll.scrollTop();
    const pageTop = $($token.closest('.page-preview-window')[0]).position().top;

    let top = tokenTop + pageTop + scrollTop - scrollHeight + (tokenHeight / 2);
    if (center) top += this.$builderContainerScroll.height() / 2;

    this.$builderContainerScroll.animate({
      scrollTop: top
    }, 300);
  }

  scrollToPage(pageNumber) {
    const scrollTop = this.$builderContainerScroll.scrollTop();
    const pageTop = $(`img.page-image[data-pagenum="${pageNumber}"]`)
      .closest('.page-preview-window').position().top;
    const top = scrollTop + pageTop;
    this.$builderContainerScroll.animate({
      scrollTop: top
    }, 300, _ => this.setActivePage());
  }

  getTokenById(id) {
    return this.ts.tokens.find(t => t.id === id) || null;
  }

  deselectAllTokens(checkModal=true) {
    if (checkModal && this.dom.modalOpen) return;
    this.ts.tokens.forEach(t => t._selected = false);
    this.selectedTokens = [];
    this.activeToken = undefined;
    this.activePageId = null;
    this.setTokenGroupStyle();
  }

  selectToken(token) {

    if (!token) return;
    if (this.activePageId != token.pageId) {
      this.activePageId && this.deselectAllTokens();
      this.selectPage(token.pageId);
    }
    token._selected = true;
    if (!this.selectedTokens.some(t => t.id === token.id)) {
      this.selectedTokens.push(token);
    }

    this.setTokenGroupStyle();
  }

  selectPage(pageId) {
    this.activePageId = pageId;
  }

  showTokenProperties() {
    this.openTokenModal(this.activeToken);
    this.deactivateContextMenus();
  }

  deselectActiveToken() {
    this.deselectToken(this.activeToken);
    this.deactivateContextMenus();
  }

  selectTokenReference(token) {
    this.es.dispatchEvent(
      this.es.actions.REFERENCE_SELECT_BEGIN, 
      { referenceId: token.referenceId });
    this.deactivateContextMenus();
  }

  getTokenGroupStyle() {
    const $tokenGroupSelected = $(`#token-group-selected-${this.selectedTokens[0].pageId}`);
    const dimensions = this.dom.getJqCssVals($tokenGroupSelected, ['left', 'top', 'width', 'height']);
    dimensions.right = dimensions.left + dimensions.width;
    dimensions.bottom = dimensions.top + dimensions.height;
    return dimensions;
  }

  setTokenGroupStyle() {
    this.setSelectorStyle({ left: 0, top: 0, width: 0, height: 0 }, true);
    if (this.activePageId) {
      this.es.dispatchEvent(
        this.es.actions.TOKEN_GROUP_STYLE_SET, 
        { activePageId: this.activePageId, selectedTokens: this.selectedTokens });
    }
  }

  setActivePage(pageNum) {
    if(!pageNum) {
      const activePageImage = [...document.querySelectorAll('.page-image')]
        .filter(image => {
          const rect = image.getBoundingClientRect();
          return rect.top < this.$window.innerHeight && rect.bottom > 0;
        }).pop();
      if (!activePageImage) return;
      pageNum = activePageImage.dataset.pagenum;
    }
    this.activePage = this.td.template.partialPages.find(p => p.pageNumber == pageNum);
  }

  setSelectorStyle(style, hide) {
    this.$tokenSelector.css({
      'left': style.left,
      'top': style.top,
      'width': style.width,
      'height': style.height
    });
    hide ? this.$tokenSelector.hide() : this.$tokenSelector.show();
  }

  updateTokenData() {
    this.ts.notifyUpdate(["tokens"], this.td);
    this.validateSelectOptions();
  }
  //#endregion Token selection

  //#region Modals
  closeModal() {
    this.modal?.close();
  }

  async promptLogin() {
    const { realm } = this.td?.template || { realm: '' };
    this.fs.error(`You must login to ${realm}.${this.PROVIDER.domain} before proceeding.`);
    await this.openLoginModal(realm);

    this.reloadWindow();
  }

  reloadWindow() {
    this.fs.success("Reloading now...");
    this.$timeout(() => {
      this.$window.location.reload();
    }, 1500);
  }

  changeTemplateProp(prop, templateData) {
    this.ts.notifyUpdate([prop], templateData);
  }

  setConfirmLeave() {
    const unsavedMsg = actionText => `Unsaved Changes will be lost.\nAre you sure you want to ${actionText}?`;

    this.$window.onbeforeunload = () => {
      if (this.hasUnsavedChanges() && !this.ignoreLeaveConfirm) return unsavedMsg('leave this page');
    };

    this.$state.$current.onExit = () => {
      let isLeaving = true;

      if (this.hasUnsavedChanges() && !this.ignoreLeaveConfirm) {
        const actionText = this.discardOption ? 'discard changes' : 'leave this page';
        isLeaving = confirm(unsavedMsg(actionText));
        this.discardOption = false;
      }
      if (isLeaving) this.$window.onbeforeunload = undefined;
      return isLeaving;
    };
  }

  openTokenModal(token, section = '') {
    this.deactivateContextMenus();

    if (token._loading) return;
    if (!token?.fieldSchema || token.control?.type === 'not-found') {
      this.fs.error('Field is missing!');
      return;
    }
    this.activeToken = token;
    this.originalActiveToken = angular.copy(token);
    this.tokenStyle = this.tb.getLayoutText(token.layout);
    this.invalidCss = false;
    this.activeSection = section;

    this.modal?.close();

    this.modal = this.$uibModal.open({
      backdrop: 'static',
      windowClass: 'token-modal',
      template: `<token-form
                  token="$ctrl.activeToken"
                  style="$ctrl.tokenStyle"
                  invalid-css="$ctrl.invalidCss"
                  on-update="$ctrl.tokenUpdateModal(token)"
                  section="$ctrl.activeSection"
                  on-cancel="$ctrl.cancelModal()">
                </token-form>`,
      scope: this.$scope,
      size: 'lg'
    });
    this.scrollToToken(token, true);
    this.modal.result.then(
      closed => this.tokenClosedModal(),
      canceled => this.tokenCancelModal()
    );
  }

  tokenUpdateModal(token) {
    const fieldChanged = (token.referenceId != this.originalActiveToken.referenceId || token.fieldSchema.id != this.originalActiveToken.fieldSchema.id);
    if (fieldChanged && !confirm("Changing the associated table field will reset some properties of your field. Do you want to continue?")) {
      this.tokenCancelModal();
      this.closeModal();
      return;
    }

    token.layout = this.tokenStyle;
    this.updateTokenData();
    this.closeModal();

    this.scrollToToken(token, true);
    this.$timeout(() => { 
      fieldChanged && this.changeTokenFieldId(token);
      this.loadFonts(); 
      this.selectToken(token); 
    }, 400);
  }

  async restoreTemplateVersion(data) {
    this.modal?.close();

    if (!data.clone) {
      this.restoreTemplateVersionModal(data.versionRecord);
      return;
    }
    if (!confirm(`Are you sure you want to create a new template using version ${data.versionRecord.versionNumber}?`)) return;
    await this.saveChangesAs(data.versionRecord.versionNumber);
  }

  restoreTemplateVersionModal(versionRecord) {

    if (this.hasUnsavedChanges()) {
      this.fs.error('Please save or discard your changes before restoring a version!');
      return;
    }

    this.versionRecord = versionRecord;
    this.modal = this.$uibModal.open({
      backdrop: 'static',
      windowClass: 'restore-template-modal',
      template: `<restore-template
                  version-record="$ctrl.versionRecord"
                  template="$ctrl.td.template"
                  on-update="$ctrl.reloadWindow()"
                  on-cancel="$ctrl.cancelModal()">
                </token-form>`,
      scope: this.$scope,
      size: 'md'
    });
    this.modal.result.then(
      closed => this.closeModal(),
      canceled => this.closeModal()
    );
  }

  changeTokenFieldId(token) {

    const tableId = this.ts.refById(token.referenceId).tableId;
    const offset = this.dom.getJqToken(token)[0].getBoundingClientRect();
    const containerOffset = this.$builderContainerScroll[0].getBoundingClientRect();
    const scrollTop = this.$builderContainerScroll.scrollTop();
    const position = { left: offset.left - containerOffset.left, top: offset.top-containerOffset.top + scrollTop};

    const ui = { helper: [{ dataset: { referenceId: token.referenceId, fieldId: token.fieldSchema.id, tableId }}], position };
    const event = { target: { dataset: { pageId: token.pageId }}};

    token._css = this.tb.getCssObj(token.layout);
    ["height", "width", "font-size", "line-height"].forEach( prop => delete token._css[prop]);

    token._options = token?.options?.label ? { label: token.options.label } : undefined;

    this.addNewToken(event, ui, token);
  }

  tokenClosedModal() {
    this.activeToken && this.ts.setTokenBehaviorsFlag(this.activeToken);
  }

  tokenCancelModal() {
    let tokenIndex = this.td.template.tokens.findIndex(t => t.id == this.activeToken.id);

    this.td.template.tokens[tokenIndex] = { 
      ...angular.copy(this.originalActiveToken) 
    };

    this.activeToken = this.originalActiveToken = undefined;

    this.deselectAllTokens();
    this.$timeout(() => this.selectToken(this.td.template.tokens[tokenIndex]));
  }

  openLoginModal(realm) {
    const { prefix, id } = this.PROVIDER;
    return new Promise((resolve, reject) => {
      const loginModal = this.$uibModal.open({
        template: `<${prefix}-login options="$ctrl.loginOptions"></${prefix}-login>`,
        scope: this.$scope,
        backdrop: 'static',
        keyboard: false,
        size: 'md'
      });

      this.loginOptions = {
        realm,
        title: `Login to ${realm}.${id.toLowerCase()}`,
        onSuccess: (user) => {
          loginModal.dismiss("Canceled");
        }
      };

      loginModal.result.then(
        closed => { resolve() },
        canceled => { resolve() }
      );

    });
  }

  async openTemplateOptions(refId, highlightSection) {
    this.targetTableId = refId;
    this.highlightSection = highlightSection;
    const optionsTemplate =
      `<template-options
        template="$ctrl.td.template"
        reference-id=$ctrl.targetTableId
        ignore-leave-confirm=$ctrl.ignoreLeaveConfirm
        highlight-sec=$ctrl.highlightSection
        on-cancel="$ctrl.cancelModal()">
      </template-options>`;

    this.modal = this.$uibModal.open({
      template: optionsTemplate,
      scope: this.$scope,
      size: "xlg"
    });

    this.modal.result.then(
      closed => null,
      canceled => { 
        if (this.selectedTokens.length === 1) 
          this.scrollToToken(this.selectedTokens[0], true); 
      }
    );
  }

  cancelModal() {
    this.modal.dismiss("Canceled");
  }

  async updateConnection() {
    const uibModal = { scope: this.$scope, size: "md", backdrop: false };
    this.connTemplate = { id: this.ts.templateId, provider: await this.as.provider(), realm: await this.as.realm(), connectionId: this.ts.template.connectionId  };
    uibModal.template =
      `<conn-update
          title="'Update Invalid Template Connection'"
          ignore-stored-conn="true"
          ignore-leave-confirm="$ctrl.ignoreLeaveConfirm"
          template="$ctrl.connTemplate">
        </conn-update>`;
    
    this.modal = this.$uibModal.open(uibModal);
    this.modal.result.then(
      closed => this.closeModal(),
      canceled => this.closeModal()
    );
  }
  //#endregion Modals

  //#region Utils
  copyUrlToClip(action) {
    const value = this.td.template.id;
    this.uc.copyToClipboard(action, this.td.template);
  }

  designerIsFocused() {
    return (document.activeElement.tagName.toLowerCase() === 'body');
  }

  isAppAssigned() {
    return !!(this.td?.template || {}).appId;
  }

  validateTemplateSettings(checkConn) {
    this.tv.validateGroup(this.tv.validationGroups.TEMPLATE_SETTINGS, { template: this.td.template, ss: this.ss, checkConn });
  }

  validateMissingRequired() {
    this.tv.validateGroup(this.tv.validationGroups.REQUIRED_FIELDS, { template: this.td.template, schemas: this.ss.schemas });
  }

  validateTableFields() {
    this.tv.validateGroup(this.tv.validationGroups.TABLE_FIELDS, { template: this.td.template });
  }

  validateChoiceFields() {
    this.tv.validateGroup(this.tv.validationGroups.FIELD_CHOICES, { template: this.td.template });
  }
  
  validateSelectOptions() {
    this.tv.validateGroup(this.tv.validationGroups.SELECT_OPTIONS, { template: this.td.template });
  }

  validateEmptyReferences() {
    this.tv.validateGroup(this.tv.validationGroups.EMPTY_REFERENCES, { template: this.td.template });
  }

  //#endregion Utils

  //#region token drop
  /**
   * Add a new Template Page Token to the formTemplatePage. Uses the Jquery
   * event and ui helper object to compose the layout and type.
   * @param {object} event - The Jquery event object
   * @param {object} ui - The Jquery ui helper object. Contains position
   *                      and size information needed.
  */
  async onTokenDrop(event, ui) {
    // Position is calculated based on dropped item position relative to window position.
    const $helper = $(ui.helper[0]);
    $helper.removeClass('toolbox-token').attr('id', 'token-new-drop');
    ui.position = this.dom.getRelativeOffset($helper, $(event.target));
    const token = await this.addNewToken(event, ui);
    event.originalEvent._tokenLoadCallback && event.originalEvent._tokenLoadCallback(token); 
  }

  shouldOpenModal(token) {
    return token.fieldSchema.isFile || token.control.embedUrlType;
  }
  
  async addNewToken(event, ui, srcToken) {
    const { pageId } = event.target.dataset;
    const { referenceId, fieldId, tableId } = ui.helper[0].dataset;
    // Set intial token data before control info available
    const token = this.ts.initializeNewToken(referenceId, fieldId, pageId);
    token.fieldSchema = this.ss.schemas[tableId].fields.find(f => f.id == token.fieldId);
    token.id = srcToken?.id || token.id;
    token.options = srcToken?._options;
    if (this.PROVIDER.allowMultipleAttachments && fieldId == 'form_engine_attachment') {
      token.fieldId += '_' + Date.now();
    }

    let css = this.tb.getInitialCss(ui.position, token, this.pageZoom);
    this.tb.applyCssLayout(token, css, !srcToken);

    token._loading = true;
    this.tokenLoadCount++;

    srcToken && this.deleteTokens([srcToken], false);
    this.td.template.tokens.push(token);
    this.updateTokenData();

    $("#token-new-drop").hide(); // Avoid duplicate field in toolbox

    try {
      const { data: { controls } } = await this.ts.fetchControls([token]);
      token.control = controls[0];
      if (!srcToken && token.control?.type === 'text-control') {
        token.options = { ...token.options, adjustFontToFit: true };
      }
    }
    catch (error) {
      this.deleteTokens([token]);
      this.handleError(error, false);
      return;
    }
    finally {
      this.tokenLoadCount--;
    }

    css = this.tb.getInitialCss(ui.position, token, this.pageZoom);
    css = { ...css, ...(srcToken?._css || {}) };
    this.tb.applyCssLayout(token, css, false);

    delete token._loading;
    this.updateTokenData();

    this.validateMissingRequired();
    this.validateEmptyReferences();
    this.deselectAllTokens();

    this.$timeout(_ => {
      this.tabNumbers = null;
      this.tb.safeApplyTokenCss(token); // adjust drop if off page boundaries 
      this.selectToken(token);
      if (this.shouldOpenModal(token)) this.openTokenModal(token);
    });

    return(token);
  }

  //#endregion token drop

  //#region background events
  backgroundClick() {
    this.deactivateContextMenus();
    this.deselectAllTokens();
  }

  backgroundDoubleClick() {
    this.openTemplateOptions();
  }

  backgroundDragOver(event) {
    this.selectorBox.width = (event.clientX - this.selectorBox.left);
    this.selectorBox.height = (event.clientY - this.selectorBox.top);
    
    const fixedStyle = {...this.selectorBox};
    if (fixedStyle.width < 0) {
      fixedStyle.width *= -1;
      fixedStyle.left -= fixedStyle.width;
    }
    if (fixedStyle.height < 0) {
      fixedStyle.height *= -1;
      fixedStyle.top -= fixedStyle.height;
    }
    this.setSelectorStyle(fixedStyle, false);
  }

  backgroundDragStart(event) {
    this.deactivateContextMenus();
    this.selectorBox = { top: event.clientY, left: event.clientX, width: 0, height: 0 };
    event?.originalEvent?.dataTransfer?.setDragImage(this.dragImage, 0, 0);
    event?.dataTransfer?.setDragImage(this.dragImage, 0, 0);
    this.ctrlDrag = this.dom.isCtrlPressed(event);
    this.setSelectorStyle({ left: 0, top: 0, width: 0, height: 0 }, true);
  }

  backgroundDragEnd() {
    let pageId = null;
    const selectorRect = $("#token-selector")[0].getBoundingClientRect();
    if (!this.ctrlDrag) this.deselectAllTokens();
    else if (this.selectedTokens.length) pageId = this.selectedTokens[0].pageId;

    this.td.template.tokens.forEach(token => {
      if (token._selected) return;
      const tokenRect = this.dom.getJqToken(token)[0]?.getBoundingClientRect();
      if (tokenRect && this.dom.isCaptured(tokenRect, selectorRect)) {
        pageId = pageId || token.pageId;
        if (token.pageId == pageId) this.selectToken(token);
      }
      
    });

    this.resetSelectorDimensions();
    this.setTokenGroupStyle();
    this.$scope.$apply();
  }

  resetSelectorDimensions() {
    this.$timeout(() => { this.selectorDimensions = { top: -100, left: -100, right: -100, bottom: -100 } });
  }
  //#endregion background events

  //#region context menus
  mouseEnteredBuildHeader(){
    this.deactivateContextMenus();
  }

  activateTokenContextMenu($event) {
    this.deactivateContextMenus();
    this.showTokensContextMenu = true;
    this.$timeout(_ => this.positionContextMenu($event, this.$tokensContextMenu));
  }

  activatePageContextMenu($event) {
    this.deactivateContextMenus();
    this.showPageContextMenu = true;
    this.$timeout(_ => this.positionContextMenu($event, this.$pageContextMenu));
  }

  deactivateContextMenus() {
    this.showTokensContextMenu = false;
    this.showPageContextMenu = false;
  }

  positionContextMenu($event, element) {
    let offsetTop = 0, offsetLeft = 0;
    element.css({ position: "fixed", display: "block" });

    const vh = Math.max(document.documentElement.clientHeight || 0, this.$window.innerHeight || 0);
    const vw = Math.max(document.documentElement.clientWidth || 0, this.$window.innerWidth || 0);

    if ($event.clientY > vh/2.5) {
      offsetTop = element.height();
    }
    if ($event.clientX > vw / 2) {
      offsetLeft = element.width();
    }
    
    element.css({
      left: `${($event.clientX - offsetLeft)}px`, top: `${Math.max($event.clientY - offsetTop, 130)}px`
    });
    
  }
  //#endregion context menus

}

export default {
  bindings: {},
  templateUrl: "form-builder/template-builder/template-builder.component.html",
  controller: TemplateBuilderCtrl
};
